import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../../../contexts/LocaleContext';
import './Header.css';
import icon from '../../assets/images/icon.png';

const Header: React.FC = () => {
  const { language, setLanguage } = useLocale();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLanguage(e.target.value as 'en' | 'es');
  };

  return (
    <header className="ainstein-header">
      <div className="container">
        <Link to="/" className="logo">
          <img 
            src={icon} 
            alt="AInstein Icon" 
            className="logo-icon"
            width={24}
            height={24}
          />
          <span>AInstein</span>
        </Link>
        <div className="language-selector">
          <select 
            value={language} 
            onChange={handleLanguageChange}
            aria-label="Select language"
          >
            <option value="en">English</option>
            <option value="es">Español</option>
          </select>
        </div>
      </div>
    </header>
  );
};

export default Header;
